import "./_button.scss";

import cx from "classnames";
import React from "react";
import {MouseEvent} from "react";

const buttonVariant = (variant: string): object => {
  return {
    "button-component--primary": variant.includes("primary"),
    "button-component--secondary": variant.includes("secondary"),
    "button-component--tertiary": variant.includes("tertiary"),
    "button-component--validate": variant.includes("validate"),
    "button-component--negate": variant.includes("negate"),
    "button-component--onlyIcon": variant.includes("icon"),
    "button-component--circle": variant.includes("circle"),
    "button-component--disabled": variant.includes("disabled"),
  };
};

function Button({
  label,
  onClick,
  value,
  variant = "primary",
  type = "button",
  icon = undefined,
  className = "",
}: {
  label?: string;
  value?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  variant?: string;
  type?: "submit" | "button" | "reset";
  icon?: string | React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  className?: string;
}): JSX.Element {
  const handleClick = (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
  ): void => {
    onClick(event);
  };
  return (
    <button
      value={value}
      className={cx("button-component", buttonVariant(variant), className)}
      onClick={type !== "submit" ? handleClick : undefined}
      type={type}>
      {icon ? (
        typeof icon === "string" ? (
          <img src={icon} alt={`icon button ${label}`} />
        ) : (
          React.createElement(icon)
        )
      ) : null}
      {label}
    </button>
  );
}

export default Button;
